import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useAppDispatch } from 'app/store';
import { memo } from 'react';
import { uiModel } from 'entities/ui';
import { useDuplicateErrorRow, useIntervalErrorRow } from '../../hooks';
import style from './index.module.scss';

interface IProps {
  id: number;
}

export const ButtonDelete: React.FC<IProps> = memo(({ id }) => {
  const dispatch = useAppDispatch();

  const duplicateRow = useDuplicateErrorRow(id);
  const intervalErrorRow = useIntervalErrorRow(id);

  const onDelete = () => {
    dispatch(uiModel.Absence.actions.removeRow(id));
    // Для дубликата и строки с ошибкой пересечения дат, обновляем поля ошибки
    if (duplicateRow || intervalErrorRow) {
      const duplicatedRows = duplicateRow
        ? [
            {
              id: duplicateRow.tableId,
              changes: { errors: duplicateRow.errors ? { ...duplicateRow.errors, duplicate: null } : undefined },
            },
          ]
        : [];
      const intervalRows = intervalErrorRow
        ? [
            {
              id: intervalErrorRow.tableId,
              changes: { errors: intervalErrorRow.errors ? { ...intervalErrorRow.errors, interval: null } : undefined },
            },
          ]
        : [];
      dispatch(uiModel.Absence.actions.updateRows([...duplicatedRows, ...intervalRows]));
    }
  };

  return (
    <Popconfirm
      title="Вы уверены, что хотите удалить неявку?"
      placement="left"
      onConfirm={onDelete}
      okText="Удалить"
      cancelText="Назад"
      overlayClassName={style.root}
    >
      <Button icon={<DeleteOutlined />} type="link" danger />
    </Popconfirm>
  );
});
